export const MAX_UNACKNOWLEDGED_EMISSIONS = 50;

export type ContentSync = {
  readonly editorContent: string;
  readonly unacknowledged: readonly string[];
};

export type IncomingContentResolution = {
  readonly shouldApply: boolean;
  readonly sync: ContentSync;
};

export const createContentSync = (content: string): ContentSync => ({
  editorContent: content,
  unacknowledged: [],
});

export const recordEmission = (
  sync: ContentSync,
  emitted: string
): ContentSync => ({
  editorContent: emitted,
  unacknowledged: [...sync.unacknowledged, emitted].slice(
    -MAX_UNACKNOWLEDGED_EMISSIONS
  ),
});

export const resolveIncomingContent = (
  sync: ContentSync,
  incoming: string
): IncomingContentResolution => {
  const echoIndex = sync.unacknowledged.indexOf(incoming);
  if (echoIndex !== -1) {
    return {
      shouldApply: false,
      sync: {
        editorContent: sync.editorContent,
        unacknowledged: sync.unacknowledged.slice(echoIndex + 1),
      },
    };
  }
  if (incoming === sync.editorContent) {
    return { shouldApply: false, sync };
  }
  return { shouldApply: true, sync: createContentSync(incoming) };
};
